import { Component } from '@angular/core';

@Component({
    selector: 'vg-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
    image_tc1 = 'vg/footer/mastercard.svg';
    image_tc2 = 'vg/footer/visa.svg';
    image_tc3 = 'vg/footer/amex.svg';
    image_pl1 = 'vg/footer/paypal.svg';
    image_pl2 = 'vg/footer/rappi.svg';
    image_pl3 = 'vg/footer/kueski.svg';
    image_pl4 = 'vg/footer/uplift.svg';
    image_rs1 = 'vg/footer/facebook.svg';
    image_rs2 = 'vg/footer/instagram.svg';
    image_rs3 = 'vg/footer/twitter.svg';
    image_rs4 = 'vg/footer/tiktok.svg';
    image_rs5 = 'vg/footer/linkedin.svg';
    image_rs6 = 'vg/footer/youtube.svg';
    image_st1 = 'vg_footer_img_url-app-store';
    image_st2 = 'vg_footer_img_url-google-play';
    image_st3 = 'vg_footer_img_url-app-gallery';
    image_pa1 = 'vg/footer/iso_9001.svg';
    image_pa2 = 'vg/footer/navitaire.svg';
    image_pa3 = 'vg/footer/pci.svg';
    link_appstore = 'https://apple.co/3KD2WOu';
    link_googleplay = 'https://bit.ly/viva-app-android';
    link_appgallery = 'https://appgallery.huawei.com/app/C106561485';
    link_facebook = 'https://www.facebook.com/VivaAerobus/';
    link_instagram = 'https://www.instagram.com/vivaaerobus/';
    link_twitter = 'https://twitter.com/VivaAerobus';
    link_tiktok = 'https://www.tiktok.com/@vivaaerobus';
    link_linkedin = 'https://mx.linkedin.com/company/vivaaerobus';
    link_youtube = 'https://www.youtube.com/@VivaAerobusMX/';
}
